import React, { useState, useLayoutEffect, useEffect, useRef } from 'react';

// helpers
import { updateStyle } from '@/lib/domHelpers';

import Box from '@mui/material/Box';
import { FieldInput } from '@/components/Tables/Cells/ListCell/StyledComponents';

const AutoTextArea = ({ onChange, value, className, refsProxy, ...rest }) => {
  const textAreaRef = useRef(null);
  const parentRef = useRef(null);

  const [text, setText] = useState('');
  const [textAreaHeight, setTextAreaHeight] = useState('auto');
  const [textAreaTopPosition, setTextAreaTopPosition] = useState(0);
  const [textAreaLeftPosition, setTextAreaLeftPosition] = useState(0);
  const [parentHeight, setParentHeight] = useState('auto');
  const [parentWidth, setParentWidth] = useState('auto');
  const [maxAreaHeight, setMaxAreaHeight] = useState('auto');

  const scrollBox =
    document.querySelector('[data-element="je.grid.float"]') || document.querySelector('.search-scroll-box');

  const jeWrapper = document.querySelector('[data-element="content.document.tableBlock"]');

  const disableScroll = () => {
    if (scrollBox) {
      updateStyle(scrollBox, [{ name: 'overflow', value: 'hidden' }]);
      scrollBox.setAttribute('data-scroll-box', 'open');
    }
    if (jeWrapper) {
      updateStyle(jeWrapper, [{ name: 'overflow', value: 'hidden' }]);
      jeWrapper.setAttribute('data-scroll-box', 'open');
    }
  };

  const enableScroll = () => {
    if (scrollBox) {
      updateStyle(scrollBox, [{ name: 'overflow', value: null }]);
      scrollBox.removeAttribute('data-scroll-box');
    }
    if (jeWrapper) {
      updateStyle(jeWrapper, [{ name: 'overflow', value: null }]);
      jeWrapper.removeAttribute('data-scroll-box');
    }
  };

  useEffect(() => {
    setParentHeight(`${textAreaRef.current.scrollHeight}px`);
    setTextAreaHeight(`${textAreaRef.current.scrollHeight}px`);
  }, [text]);

  useLayoutEffect(() => {
    disableScroll();
    setParentWidth(`${parentRef.current.offsetWidth}px`);
    setText(value);
    const { top, left } = parentRef.current.getBoundingClientRect();
    const maxHeight = window.innerHeight - top - 60;
    setMaxAreaHeight(`${maxHeight}px`);
    refsProxy(textAreaRef.current);
    setTextAreaTopPosition(top);
    setTextAreaLeftPosition(left);

    return () => {
      enableScroll();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeHandler = (event) => {
    setTextAreaHeight('auto');
    setText(event.target.value);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <Box
      sx={{ position: 'absolute', zIndex: 10, width: '100%' }}
      ref={parentRef}
      style={{
        height: parentHeight,
      }}
    >
      <FieldInput
        as="textarea"
        {...rest}
        value={text}
        ref={textAreaRef}
        rows={1}
        style={{
          height: textAreaHeight,
          maxHeight: maxAreaHeight,
          width: parentWidth,
          paddingTop: 6,
          paddingBottom: 3,
          paddingRight: 1,
          top: textAreaTopPosition,
          left: textAreaLeftPosition,
        }}
        onChange={onChangeHandler}
      />
    </Box>
  );
};

export default AutoTextArea;
